var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import { CreatePromptDocument, UpdatePromptDocument, } from './query.gql';
import { PromptLibraryListPromptsDocument } from '../../PromptLibraryProvider/usePrompts/Queries.gql';
export function useUpsertPrompt() {
    const [createMutation, createState] = useMutation(CreatePromptDocument);
    const [updateMutation, updateState] = useMutation(UpdatePromptDocument);
    const loading = createState.loading || updateState.loading;
    const error = createState.error || updateState.error;
    const handleCreatePrompt = (variables) => __awaiter(this, void 0, void 0, function* () {
        return createMutation({
            variables,
            refetchQueries: [PromptLibraryListPromptsDocument],
            update(cache, { data }) {
                const { documentAssistantPrompt } = data || {};
                if (documentAssistantPrompt) {
                    cache.modify({
                        fields: {
                            documentAssistantPrompts(existing) {
                                return Object.assign(Object.assign({}, existing), { totalCount: existing.totalCount + 1, items: [documentAssistantPrompt, ...existing.items] });
                            },
                        },
                    });
                }
            },
        });
    });
    const handleUpdatePrompt = (variables) => __awaiter(this, void 0, void 0, function* () {
        return updateMutation({
            variables: {
                id: variables.id,
                input: variables.input,
            },
            refetchQueries: [PromptLibraryListPromptsDocument],
        });
    });
    return { create: handleCreatePrompt, update: handleUpdatePrompt, loading, error };
}
